"use strict";
import React, { useLayoutEffect, useRef } from "react";
let nextOrder = 0;
const mountedTitles = /* @__PURE__ */ new Map();
function applyTitle() {
  var _a;
  const innermost = Math.max(...mountedTitles.keys());
  const title = (_a = mountedTitles.get(innermost)) != null ? _a : "";
  if (document.title !== title) {
    document.title = title;
  }
}
export default function DocumentTitle({
  title,
  children
}) {
  const orderRef = useRef(null);
  if (orderRef.current === null) {
    orderRef.current = nextOrder++;
  }
  useLayoutEffect(() => {
    const order = orderRef.current;
    return () => {
      mountedTitles.delete(order);
      applyTitle();
    };
  }, []);
  useLayoutEffect(() => {
    mountedTitles.set(orderRef.current, title);
    applyTitle();
  }, [title]);
  return children ? React.Children.only(children) : null;
}
